import { createSlice } from '@reduxjs/toolkit';
import { getStripeCustomerId, updateStripeCustomerId } from './orgs.thunks';
import { OrgsState } from './orgs.types';

export const initialState: OrgsState = {
  isLoading: {
    getStripeCustomerId: false,
    updateStripeCustomerId: false,
  },
  isError: {
    getStripeCustomerId: false,
    updateStripeCustomerId: false,
    createOrg: false,
  },
  stripeCustomerId: null,
};

export const orgsSlice = createSlice({
  name: 'orgsNew',
  initialState,
  reducers: {
    clearStripeCustomerId: (state) => {
      state.stripeCustomerId = null;
    },
    clearStripeCustomerIdErrors: (state) => {
      state.isError.getStripeCustomerId = false;
      state.isError.updateStripeCustomerId = false;
      state.isError.createOrg = false;
    },
    throwCreateOrgError: (state) => {
      state.isError.createOrg = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStripeCustomerId.pending, (state) => {
      state.isLoading.getStripeCustomerId = true;
      state.isError.getStripeCustomerId = false;
      state.isError.updateStripeCustomerId = false;
      state.isError.createOrg = false;
    });
    builder.addCase(getStripeCustomerId.fulfilled, (state, action) => {
      state.isLoading.getStripeCustomerId = false;
      state.stripeCustomerId = action.payload;
    });
    builder.addCase(getStripeCustomerId.rejected, (state, action) => {
      state.isLoading.getStripeCustomerId = false;
      state.isError.getStripeCustomerId = !action.meta.aborted;
    });
    builder.addCase(updateStripeCustomerId.pending, (state) => {
      state.isLoading.updateStripeCustomerId = true;
      state.isError.getStripeCustomerId = false;
      state.isError.updateStripeCustomerId = false;
      state.isError.createOrg = false;
    });
    builder.addCase(updateStripeCustomerId.fulfilled, (state, action) => {
      state.isLoading.updateStripeCustomerId = false;
      state.stripeCustomerId = action.payload;
    });
    builder.addCase(updateStripeCustomerId.rejected, (state, action) => {
      state.isLoading.updateStripeCustomerId = false;
      state.isError.updateStripeCustomerId = !action.meta.aborted;
    });
  },
});

export const {
  clearStripeCustomerId,
  clearStripeCustomerIdErrors,
  throwCreateOrgError,
} = orgsSlice.actions;

export default orgsSlice.reducer;
